import { BaseItem, ItemType, Rarity } from "./BaseItem";
import { ModifyAllSectionScoresEffect, ModifyScoreEffect, ModifySectionScoreEffect, MultiplyScoreEffect } from "./Effects";

export interface Charm extends BaseItem {
  key: Charms;
}

export const enum Charms {
  LUCKY_COIN = "Lucky Coin",
  MOLAR = "Molar",
  PILL = "Random Pill",
  LUCKYCLOVER = "Lucky Clover",
  GEAR = "Gear",
  TIPJAR = "Tip Jar",
}

export const CharmData: { [key in Charms]: Charm } = {
  [Charms.LUCKY_COIN]: {
    key: Charms.LUCKY_COIN,
    itemType: ItemType.CHARM,
    rarity: Rarity.COMMON,
    textureKey: "items",
    frameKey: "item_goldenCoin.png",
    effects: [new ModifyScoreEffect(50, 10)],
    value: 3,
  },
  [Charms.MOLAR]: {
    key: Charms.MOLAR,
    itemType: ItemType.CHARM,
    rarity: Rarity.UNCOMMON,
    textureKey: "items",
    frameKey: "item_molar.png",
    effects: [new ModifyScoreEffect(30, -1)],
    value: 8,
  },
  [Charms.PILL]: {
    key: Charms.PILL,
    itemType: ItemType.CHARM,
    rarity: Rarity.UNCOMMON,
    textureKey: "items",
    frameKey: "item_pill.png",
    effects: [new ModifySectionScoreEffect(30, -1)],
    value: 8,
  },
  [Charms.LUCKYCLOVER]: {
    key: Charms.LUCKYCLOVER,
    itemType: ItemType.CHARM,
    rarity: Rarity.RARE,
    textureKey: "items",
    frameKey: "item_luckyClover.png",
    effects: [new MultiplyScoreEffect(1.2, -1)], // x1.2 multiplier, infinite duration
    value: 14,
  },
  [Charms.GEAR]: {
    key: Charms.GEAR,
    itemType: ItemType.CHARM,
    rarity: Rarity.RARE,
    textureKey: "items",
    frameKey: "item_gear.png",
    effects: [new ModifyAllSectionScoresEffect(10, 5)],
    value: 15,
  },
  [Charms.TIPJAR]: {
    key: Charms.TIPJAR,
    itemType: ItemType.CHARM,
    rarity: Rarity.EPIC,
    textureKey: "items",
    frameKey: "item_tipjar.png",
    effects: [new ModifyAllSectionScoresEffect(10, -1)],
    value: 22,
  },
};
